<template>
  <div class="adm_main" style="overflow:hidden;background-color:white;"
    v-if="$parent.currentUser.adm_users">
    <b-row>
     <b-col sm="1">
       <b-button
        @click="doSearch"
        variant="primary">
         {{ userQ ? "Search" : "Refresh" }}
       </b-button>
     </b-col>
     <b-col sm="2">
       <b-input @keydown.enter.native="doSearch"
        placeholder="email filter"
        v-model.trim="userQ">
       </b-input>
     </b-col>
     <b-col>
       <b-pagination
         v-model="currentPage"
         :total-rows="totalRows"
         :per-page="perPage"
         first-number
         last-number
         pills
         limit="8"
         @input="inputFn">
       </b-pagination>
     </b-col>
    </b-row>
    <b-row>
     <b-col sm="1">
       <b-button
        @click="newUser"
        variant="primary">
         New
       </b-button>
     </b-col>
     <b-col sm="2">
       <span v-if="!user_max" class="limits">
         Users {{ user_cnt }}
       </span>
       <span v-if="user_max" class="limits">
         Users {{ user_cnt }} / {{ user_max }}
       </span>
     </b-col>
     <b-col sm="2">
       <span v-if="!room_max" class="limits">
         Rooms {{ room_cnt }}
       </span>
       <span v-if="room_max" class="limits">
         Rooms {{ room_cnt }} / {{ room_max }}
       </span>
     </b-col>
    </b-row>
    
    <b-table stacked="md"
      :items="users"
      :fields="userFields"
      small>
      <template v-slot:cell(email)="data">         
         <div v-if="!data.item.is_new">
           {{ data.item.email }}
         </div>
         <b-input v-if="data.item.is_new" v-model.trim="data.item.edit_email">
         </b-input>
      </template>
      <template v-slot:cell(first_name)="data">
         <b-input v-model.trim="data.item.edit_first_name"> </b-input>
      </template>
      <template v-slot:cell(last_name)="data">
         <b-input v-model.trim="data.item.edit_last_name"> </b-input>
      </template>
      <template v-slot:cell(room)="data">
         <b-input v-model.trim="data.item.edit_room"> </b-input>
      </template>
      <template v-slot:cell(active)="data">
         <b-form-checkbox v-model="data.item.edit_active"> </b-form-checkbox>
      </template>
      <template v-slot:cell(save)="data">
         <b-button v-if="!changedUser(data.item)"
          class="btn_thin"
          variant="outline-danger"
          @click="delUser(data.item)"
          small>
           Delete
         </b-button>
         <b-button v-if="changedUser(data.item)"
          class="btn_thin"
          variant="warning"
          @click="undoUser(data.item)"
          small>
           X
         </b-button>
         <b-button v-if="changedUser(data.item)"
          class="btn_thin"
          variant="primary"
          @click="updateUser(data.item)"
          small>
           Save
         </b-button>
      </template>
   </b-table>
   <b-modal v-model="modalDeleteConfirm"
     @ok="deleteSelectedUser">
     Confirm deleting user.
   </b-modal>
  </div>
</template>

<script>
import vx_api from "../vuemix";
import { sync } from "vuex-pathify";

export default {
  name: "admuser",
  components: {},
  created() {
    this.inputFn();
  },
  data() {
    return {
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
      users:[],
      userFields:[
        {key:'email',label:"Email"},
        {key:'first_name',label:"First Name"},
        {key:'last_name',label:"Last Name"},
        {key:'room',label:"Room"},
        {key:'active',label:"Active"},
        {key:'sign_ins',label:"Logins"},
        {key:'save',label:""},
      ],
      userQ: "",
      modalDeleteConfirm: false,
      user_cnt: null,
      user_max: null,
      room_cnt: null,
      room_max: null,      
    };
  },
  methods: {
    getAccLimits: function() {
      let vue = this;
      let pg = vue.currentPage-1;
      let z = vue.perPage;
      let url = "https://"+vx.subd+".vuemix.com/api/v2/accounts/self.json";
      issue_http({ url: url, type: "GET",
                   contentType: "application/json",
                   done: function(status, data) {
                      let items = [];
                      if (status == 200) {
                        let j = to_json(data);
                        vue.room_max = j.data.room_max;
                        vue.room_cnt = j.data.room_cnt;
                        vue.user_max = j.data.user_max;
                      } else if (status == 401) {
                        vue.$parent.signUserOut("", "You have been Signed Out", "warning");
                      }
                   }
                });    
    },
    getUsers: function() {
      let vue = this;
      let pg = vue.currentPage-1;
      let z = vue.perPage;
      let url = "https://"+vx.subd+".vuemix.com/api/v2/users.json?page="+pg+"&page_size="+z;
      if (vue.userQ) {
        url += "&q="+vue.userQ;
      }
      issue_http({ url: url, type: "GET",
                   contentType: "application/json",
                   done: function(status, data) {
                      let items = [];
                      if (status == 200) {
                        let j = to_json(data);
                        vue.totalRows = j.data.count;
                        if (!vue.userQ) {
                           vue.user_cnt = j.data.count;
                        }
                        j.data.users.forEach(function(u) {
                           if (u.email == "admin") { return; }
                           let x = {};
                           x.id = u.id;
                           x.email = x.edit_email = u.email;
                           x.first_name = x.edit_first_name = u.first_name;
                           x.last_name = x.edit_last_name = u.last_name;
                           x.room = x.edit_room = u.nick;
                           x.active = x.edit_active = u.isActive;
                           x.sign_ins = u.user_stats.total_sign_ins;
                           x.is_new = false;
                           items.push(x);
                        });
                      } else if (status == 401) {
                        vue.$parent.signUserOut("", "You have been Signed Out", "warning");
                      }
                      vue.users = items;
                   }
                });
    },
    updateUser: function(u) {
      let vue = this;
      let url = "https://"+vx.subd+".vuemix.com/api/v2/users.json";
      let data = {};
      let user_inc = 0;
      let room_inc = 0;
      if (!u.is_new) {
        if (!u.id) { return; }
        data.id = u.id;
      } else {
        if (!u.edit_email) { return; }
        data.password = Math.random().toString(36).substring(2,15);
        user_inc = 1;
      }
      if (u.email != u.edit_email) {
        data.email = u.edit_email;
      }
      if (u.first_name != u.edit_first_name) {
        data.first_name = u.edit_first_name;
      }
      if (u.last_name != u.edit_last_name) {
        data.last_name = u.edit_last_name;
      }
      if (u.room != u.edit_room) {
        data.nick = u.edit_room;
        if (!u.room) {
           room_inc = 1;
        } else if (!u.edit_room) {
           room_inc = -1;
        }
      }
      if (u.active != u.edit_active) {
        data.isActive = u.edit_active;
      }
      issue_http({ url: url, type: "POST",
                   contentType: "application/json",
                   data: JSON.stringify(data),
                   done: function(status, data) {
                      let j = to_json(data);
                      if (status != 200 || j.status != 200) {
                        let msg = "Save failed";
                        if (j.message) { msg = j.message; }
                        vue.$parent.notification = {
                          alertCountDown: 3,
                          alertVariant: "danger",
                          alertMessage: msg,
                        };                         
                      } else {
                        u.email = u.edit_email;
                        u.first_name = u.edit_first_name;
                        u.last_name = u.edit_last_name;
                        u.room = u.edit_room;
                        u.active = u.edit_active;
                        u.is_new = false;
                        if (!u.id) {
                          u.id = j.data.id;
                        }
                        vue.room_cnt += room_inc;
                        vue.user_cnt += user_inc;
                     }
                   }
                });
    },
    deleteSelectedUser: function() {
      let vue = this;
      let x = vue.selectedUser;
      let url = "https://"+vx.subd+".vuemix.com/api/v2/users/";
      let room_inc = 0;
      if (!x || !x.id) { return; }
      url += x.id;
      if (x.room) {
         room_inc = -1;
      }
      vue.selectedUser = null;
      issue_http({ url: url, type: "DELETE",
                   contentType: "application/json",
                   done: function(status, data) {
                      let j = to_json(data);
                      if (status != 200 || j.status != 200) {
                        vue.$parent.notification = {
                          alertCountDown: 3,
                          alertVariant: "danger",
                          alertMessage: "Delete Failed",
                        };
                      } else {
                        vue.users = vue.users.filter(function(u) {
                          if (u.id == x.id) { return false; }
                          return true;
                        });
                        vue.room_cnt += room_inc;
                        vue.user_cnt --;
                      }
                   }
                 });
    },
    inputFn: function(pg) {
      let vue = this;
      /* Basically 'refresh' */
      vue.doSearch();
    },
    changedUser: function(u) {
      if (u.email != u.edit_email) {
        return true;
      }
      if (u.first_name != u.edit_first_name) {
        return true;
      }
      if (u.last_name != u.edit_last_name) {
        return true;
      }
      if (u.room != u.edit_room) {
        return true;
      }
      if (u.active != u.edit_active) {
        return true;
      }
      return false;
    },
    undoUser: function(x) {
      let vue = this;
      x.edit_email = x.email;
      x.edit_first_name = x.first_name;
      x.edit_last_name = x.last_name;
      x.edit_room = x.room;
      x.edit_active = x.active;
    },
    delUser: function(x) {
      let vue = this;
      if (!x.is_new) {
        if (!x.id) { return; }
        vue.selectedUser = x;
        vue.modalDeleteConfirm = true;
      } else {
        x.id = "found123";
        vue.users = vue.users.filter(function(u) {
          if (u.id == x.id) { return false; }
          return true;
        });
      }
    },
    newUser: function() {
      let vue = this;
      let x = {};
      x.email = x.edit_email = "";
      x.first_name = x.edit_first_name = "";
      x.last_name = x.edit_last_name = "";
      x.room = x.edit_room = null;
      x.active = null;
      x.edit_active = true;
      x.sign_ins = 0;
      x.is_new = true;
      vue.users.unshift(x);
    },
    doSearch: function() {
      let vue = this;
      if (!vue.userQ) {
         vue.getAccLimits();
      }
      vue.getUsers();
    }
  },
  mounted() {
  },
  beforeDestroy() {
  }
};
</script>
<style lang="scss">
.adm_main {
  margin: 10px;
}
.btn_thin {
  margin: 0 2px;
  padding: 3px 1px;
}
.limits {
  display:inline-block;
  padding: 0.375rem 0.75rem;  
  color:black;
  font-size:1rem;
  font-weight:400;
  background-color: #ffffb0;
  border-color: #ffffb0;
  vertical-align:middle;
  text-align:center;
  border-radius:0.25rem;
  line-height: 1.5;
}
</style>

